import z from 'zod';
import { timestampSchema, timestampRequiredSchema } from './commonSchemas.js';
import { territorialIdSchema } from './paramTypeSchema.js';
import { territorialInfoSchema } from './bonusDefSchema.js';
import { organizationDefRowSchema } from './organizationDefSchema.js';
/**
 * Schema per UserDefRow
 * Corrisponde alla struttura della tabella 'users'
 * @db_table users
 */
export const userDefRowSchema = z.object({
    /** ID dell'utente */
    id: z.number().int().positive().describe('type:number,editable:false,label:ID'),
    // ===== INFORMAZIONI PERSONALI =====
    /** Nome dell'utente */
    first_name: z.string().min(1, "Il nome è obbligatorio").describe('label:Nome'),
    /** Cognome dell'utente */
    last_name: z.string().min(1, "Il cognome è obbligatorio").describe('label:Cognome'),
    /** Data di nascita */
    birth_date: z.string().date().nullable().describe('type:date,label:Data di Nascita'),
    /** Codice fiscale italiano */
    tax_code: z.string().regex(/^[A-Z0-9]{16}$/, "Il codice fiscale deve essere di 16 caratteri alfanumerici maiuscoli").nullable().describe('label:Codice Fiscale'),
    /** Email univoca per login */
    email: z.string().email("Formato email non valido").describe('label:Email'),
    /** Numero di telefono */
    phone: z.string().max(30).nullable().describe('label:Telefono'),
    /** Indirizzo completo */
    address: z.string().nullable().describe('label:Indirizzo'),
    /** Codice postale/CAP */
    postal_code: z.string().max(10).nullable().describe('label:CAP'),
    // ===== TERRITORIO E ORGANIZZAZIONE =====
    /** Ambito territoriale diretto utente */
    ambito: territorialIdSchema.nullable().optional().describe('label:Ambito Territoriale'),
    /** ID organizzazione di appartenenza */
    organization_id: z.number().int().describe('type:organization,label:Organizzazione'),
    // ===== AUTENTICAZIONE E SICUREZZA =====
    /** Hash bcrypt della password */
    password_hash: z.string().min(1, "L'hash della password è obbligatorio").describe('type:string,label:Password'),
    /** Permesso predefinito utente */
    default_permission_id: z.number().int().positive().describe('type:permission,label:Permesso Predefinito'),
    // ===== AUTENTICAZIONE 2FA (TOTP) =====
    /** Secret Base32 per TOTP */
    totp_secret: z.string().nullable().optional().describe('label:TOTP Secret'),
    /** TOTP attivo */
    totp_enabled: z.boolean().default(false).describe('label:Doppia autenticazione'),
    /** Setup TOTP obbligatorio al primo login */
    totp_setup_required: z.boolean().default(true).describe('label:Setup TOTP Richiesto'),
    /** Array codici backup TOTP */
    totp_backup_codes: z.array(z.string()).default([]).describe('label:Codici Backup TOTP'),
    // ===== GESTIONE SESSIONI =====
    /** Timestamp ultimo accesso */
    last_login_at: timestampSchema.nullable().describe('type:datetime,editable:false,label:Ultimo Accesso'),
    /** Contatore tentativi login falliti */
    failed_login_attempts: z.number().int().min(0).default(0).describe('label:Tentativi Falliti'),
    /** Timestamp fino al quale account è bloccato */
    locked_until: timestampSchema.nullable().describe('type:datetime,label:Bloccato Fino'),
    /** Hash del refresh token JWT */
    jwt_refresh_token_hash: z.string().nullable().optional().describe('label:JWT Refresh Token Hash'),
    /** Timestamp emissione ultimo JWT */
    jwt_issued_at: timestampSchema.nullable().describe('type:datetime,label:JWT Emesso'),
    // ===== STATO ACCOUNT =====
    /** Account attivo */
    is_active: z.boolean().default(true).describe('label:Attivo'),
    /** Email verificata */
    email_verified: z.boolean().default(false).describe('label:Email Verificata,editable:false'),
    // ===== RECUPERO PASSWORD =====
    /** Token per verifica email */
    email_verification_token: z.string().nullable().optional().describe('label:Token Verifica Email'),
    /** Token per reset password */
    password_reset_token: z.string().nullable().optional().describe('label:Token Reset Password'),
    /** Scadenza token reset password */
    password_reset_expires: timestampSchema.nullable().describe('type:datetime,label:Scadenza Reset Password'),
    // ===== TIMESTAMP GESTIONE =====
    /** Data di creazione account */
    created_at: timestampRequiredSchema.describe('type:datetime,editable:false,label:Data Creazione'),
    /** Data di ultimo aggiornamento */
    updated_at: timestampRequiredSchema.describe('type:datetime,editable:false,label:Data Modifica')
});
/**
 * Schema per UserDefRowNoId
 * Schema della tabella users senza ID per inserimenti
 */
export const userDefRowSchemaNoId = userDefRowSchema.omit({
    id: true,
    created_at: true,
    updated_at: true
});
/**
 * Schema per UserDefRowView
 * Corrisponde alla vista 'users_auth_view'
 * @db_view users_auth_view
 */
export const userDefRowSchemaView = userDefRowSchema.extend({
    /** Password (alias di password_hash nella vista) */
    password: z.string().min(1),
    /** Informazioni territoriali espanse */
    territorial_info: territorialInfoSchema,
    /** Informazioni organizzazione espanse */
    organization_info: organizationDefRowSchema.nullable()
});
//# sourceMappingURL=userDefSchema.js.map